<script setup lang="ts">
const localePath = useLocalePath();
const { isLoggedIn } = useAuth();
const cookieLocale = useCookie("i18n_redirected");
const { locale } = useI18n();

const { onboardingEntry, isOnboardingDialogOpen, closeOnboardingDialog } =
  useOnboardingDialog();

const modalRedirect = useStorageSafely({
  type: "localStorage",
  key: "verifiedEmailModalRedirect",
  defaultValue: "",
});
const route = useRoute();

const { checkAndOpenOnboardingDialog } = useOpenOnboardingDialog();

debouncedWatch(
  () => route.name,
  () => {
    checkAndOpenOnboardingDialog();
  },
  { immediate: true },
);

const { isFrameTheGame } = usePlatformStore();

watch(isOnboardingDialogOpen, () => {
  const langPath = `/${cookieLocale.value || locale.value}`;

  const unLocalizedRedirect = route.fullPath.replace(langPath, "");

  modalRedirect.value = unLocalizedRedirect;
});

const onToggleFallback = (isOpening: boolean) => {
  if (!isLoggedIn && isOpening) {
    navigateTo(
      localePath({
        path: "/login",
      }),
    );
  }
};
</script>

<template>
  <BaseDialog
    v-model="isOnboardingDialogOpen"
    class="w-fit m-auto"
    size="md"
    data-test="onboarding-dialog"
    :manual-close="true"
    @close="closeOnboardingDialog"
    @toggle-fallback="onToggleFallback"
  >
    <LazyUserOnboardingFTG v-if="isFrameTheGame" />
    <LazyUserOnboardingBidding
      v-else-if="onboardingEntry?.type === OnboardingEntryType.Bid"
    />

    <LazyUserOnboardingFollow
      v-else
      :source="
        onboardingEntry?.type === OnboardingEntryType.Login
          ? 'LOGIN'
          : (onboardingEntry?.data?.source ?? 'LOGIN')
      "
    />

    <!-- extend here with other onboarding entry types -->
  </BaseDialog>
</template>
